import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "DocumentTools" }

import { computed, PropType } from "vue";
import { Document } from "@/types";
import InnForm from "@/components/ds/form/Form.vue";
import DocumentDelete from "@/components/pages/document/tools/DocumentDelete.vue";
import Tools from "@/components/general/tools/Tools.vue";
import Tool from "@/components/general/tools/Tool.vue";
import DocumentAdministration from "@/components/pages/document/tools/DocumentAdministration.vue";
import DocumentOpen from "@/components/pages/document/tools/DocumentOpen.vue";
import { useCompanyStore } from "@/stores/company";
import DocumentMail from "@/components/pages/document/tools/DocumentMail.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentTools',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    owner: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {



const companyStore = useCompanyStore();

const config1 = {
    sections: [
        {
            items: [
                {
                    type: "checkbox",
                    key: "english",
                    label: "Engelstalig",
                },
                {
                    type: "checkbox",
                    key: "hideTotal",
                    label: "Verberg totaal",
                },
                {
                    type: "number",
                    key: "rate",
                    label: "Tarief",
                },
                {
                    type: "text",
                    key: "currency",
                    label: "Valuta",
                },
                {
                    type: "number",
                    key: "vat",
                    label: "BTW",
                },
            ],
        },
    ],
};

const config2 = computed(() => {
    const drive = {
        type: "text",
        key: "google_drive_id",
        label: "Google Drive ID",
    };
    const acumulus = {
        type: "number",
        key: "acumulus_invoice_id",
        label: "Acumulus ID",
    };
    const c = {
        sections: [
            {
                items: [
                    {
                        type: "checkbox",
                        key: "paid",
                        label: "Betaald",
                    },
                ],
            },
            {
                items: [
                    {
                        type: "checkbox",
                        key: "locked",
                        label: "Lock (niet aan zitten, dit kan SSOT aantasten)",
                    },
                ],
            },
        ],
    };
    if (companyStore.company?.usesGoogleDrive) {
        c.sections[c.sections.length - 1].items.push(drive);
    }
    if (companyStore.company?.usesAcumulus) {
        c.sections[c.sections.length - 1].items.push(acumulus);
    }
    return c;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tools, null, {
      default: _withCtx(() => [
        (
                    __props.owner &&
                    (_unref(companyStore).company?.usesAcumulus ||
                        _unref(companyStore).company?.usesGoogleDrive)
                )
          ? (_openBlock(), _createBlock(Tool, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(DocumentAdministration, { document: __props.document }, null, 8, ["document"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.document.google_drive_id !== '')
          ? (_openBlock(), _createBlock(Tool, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(DocumentOpen, { document: __props.document }, null, 8, ["document"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
                    __props.owner &&
                    _unref(companyStore).company?.usesMail &&
                    __props.document.doctype === 'invoice' &&
                    __props.document.google_drive_id !== ''
                )
          ? (_openBlock(), _createBlock(Tool, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(DocumentMail, { document: __props.document }, null, 8, ["document"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!__props.document.locked)
      ? (_openBlock(), _createBlock(InnForm, {
          key: 0,
          config: config1,
          value: __props.document
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    _createVNode(InnForm, {
      config: config2.value,
      value: __props.document
    }, null, 8, ["config", "value"]),
    (__props.owner)
      ? (_openBlock(), _createBlock(Tools, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(Tool, { align: "right" }, {
              default: _withCtx(() => [
                _createVNode(DocumentDelete, { document: __props.document }, null, 8, ["document"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})